import { callClient11, getClientVersion } from '../api/index'
import { Base64 } from 'js-base64'

export default {
  data () {
    return {
      callClientProtocol: 'thunderx://QUEtUnVuVGh1bmRlckFuZFF1aXQgLVN0YXJ0U291cmNlOlRodW5kZXJVbmlvbl9Qcm90b2NhbFpaCg==',
      clientDownloadUrl: 'https://down.sandai.net/thunder11/XunLeiWebSetup_pan.exe', // 迅雷11下载地址
      clientDownLoadUrlMac: 'https://down.sandai.net/mac/thunder.dmg', // 迅雷mac下载地址
      clientClipBoardProtocol: '#$ThunderPanFetchBack:content$#', // 文件取回写入剪切板的协议
      retrieveClientVersion: '11.0.3', // 客户端支持云盘文件取回的版本
      messageTipTimer: null,
    }
  },
  methods: {
    evokeByIframe (src) {
      // iframe 模式可以同时支持外部浏览器和迅雷11内部浏览器
      const iframe = document.createElement('iframe')
      iframe.setAttribute('src', src)
      iframe.style.display = 'none'
      document.body.appendChild(iframe)
      setTimeout(() => document.body.removeChild(iframe), 2000)
    },
    onMessageTip (type, p, time = 5000, span = '') {
      const tip = { show: true, type, p, span }
      this.$store.commit('home/setTip', tip)
      if (this.messageTipTimer) {
        clearTimeout(this.messageTipTimer)
      }
      this.messageTipTimer = setTimeout(() => {
        this.$store.commit('home/setTip', {
          show: false,
        })
      }, time)
    },
    callThunderx (params = {}) {
      const url = `thunderx://${Base64.encode(JSON.stringify(params))}`
      this.evokeByIframe(url)
    },
    async callClientRetrieve ({ files, userId, fromShare, shareId, passCodeToken, shareUserId, from }) {
      try {
        const clientVersionRes = await getClientVersion()
        if (clientVersionRes.data.ret !== 0) throw new Error('获取客户端版本失败')
        if (clientVersionRes.data.version < this.retrieveClientVersion) return false
        this.onMessageTip('success', '客户端唤起中，请稍等', 3000)
        const params = {
          files,
          userId,
          fromShare,
          shareId,
          passCodeToken,
          shareUserId,
          selectNav: 'pan-plugin-view',
        }
        if (this.$native.isPC) {
          const isSupport = await this.$native.checkMessage({
            platform: 'pc',
            name: 'CreatePanExternalFetchBackTask',
          })
          if (isSupport === 0) {
            const res = await this.$native.sendMessage({
              platform: 'pc',
              name: 'CreatePanExternalFetchBackTask',
              params,
            })
            console.log('res', res)
            return true
          }
        }
        const callClientRes = await callClient11(params)
        return callClientRes.data.ret === 0
      } catch (error) {
        // this.$sentry.captureException(error)
      }
    },
  },
}
